import React from "react";
import "./loader.styles.scss";

const Loader = ({ className }) => {
  return (
    <div className={`loader ${className}`}>
      <div className="tail-loader"></div>
    </div>
  );
};

export default Loader;